import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Name",
          value: "translatableName",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Image",
          value: "translatableThumbnail",
        },
        {
          text: "Claimed",
          value: "_count.PlayerBook",
        },
        {
          text: "Completed Prologue",
          value: "totalFirstChapterReaders",
        },
        {
          text: "Completed",
          value: "completedPlayersCount",
        },
      ],
    },
  },
  read: false,
  add:false,
  edit:false,
  delete: false,
};
